import { buildInterpolatedSeries } from 'components/shared/processes/chartNoDataSeries'
import {
	ColumnTypes,
	IInspection,
	ILactation,
	ILameness,
	ITreatment,
	InspectionStatus,
	LactationStatus,
	LamenessColumnKey,
	LamenessStatus,
	LamenessTypeChart,
	PositionHoof,
	TreatmentStatus,
} from 'models'
import { LicensesType } from 'models/IUserData'
import { useState } from 'react'
import { COLORS } from 'styles/colors'

export const initialActiveColumn: ColumnTypes[] = [
	{
		key: LamenessColumnKey.TREATMENT_PLAN,
		title: 'Схема лечения',
		isShowColumn: true,
	},
	{
		key: LamenessColumnKey.DIAGNOSIS,
		title: 'Диагноз',
		isShowColumn: true,
	},
	{
		key: LamenessColumnKey.TREATMENT_STATUS,
		title: 'Статус лечения',
		isShowColumn: true,
	},
	{
		key: LamenessColumnKey.INSPECTION_DATE,
		title: 'Дата осмотра',
		isShowColumn: true,
	},
	{
		key: LamenessColumnKey.LACTATION_DAY,
		title: 'День лактации',
		isShowColumn: false,
	},
	{
		key: LamenessColumnKey.COW_AGE,
		title: 'Возраст коровы',
		isShowColumn: false,
	},
	{
		key: LamenessColumnKey.GROUP,
		title: 'Группа',
		isShowColumn: false,
	},
	{
		key: LamenessColumnKey.LACTATION_STATUS,
		title: 'Статус лактации',
		isShowColumn: false,
	},
	{
		key: LamenessColumnKey.FATNESS,
		title: 'Упитанность, балл',
		isShowColumn: false,
		requiresLicense: LicensesType.FATNESS,
	},
	{
		key: LamenessColumnKey.EXAMINER,
		title: 'Сотрудник',
		isShowColumn: false,
	},
]

export const titleForLamenessFilter = [
	{ key: 'lameness', title: 'Хромота', id: 0 },
	{ key: 'treatmentStatus', title: 'Статус лечения', id: 1 },
	{ key: 'inspectionStatus', title: 'Осмотр', id: 2 },
	{ key: 'diagnoses', title: 'Диагноз', id: 3 },
	{ key: 'cowAge', title: 'Возраст коровы', id: 4 },
	{ key: 'groups', title: 'Группа', id: 5 },
	{ key: 'lactation', title: 'Лактация', id: 6 },
	{ key: 'fatness', title: 'Упитанность, балл', id: 7 },
	{ key: 'examiners', title: 'Сотрудник', id: 8 },
]

export const lamenessStatuses: ILameness[] = [
	{ key: LamenessStatus.One, title: '1 балл', id: 0 },
	{ key: LamenessStatus.Two, title: '2 балла', id: 1 },
	{ key: LamenessStatus.Three, title: '3 балла', id: 2 },
	{ key: LamenessStatus.Four, title: '4 балла', id: 3 },
	{ key: LamenessStatus.Five, title: '5 баллов', id: 4 },
]

export const treatmentsStatuses: ITreatment[] = [
	{ key: TreatmentStatus.NotPrescribed, title: 'Не назначено', id: 0 },
	// { key: TreatmentStatus.Suspended, title: 'Приостановлено', id: 1 },
	{ key: TreatmentStatus.Treated, title: 'Лечится', id: 2 },
	{ key: TreatmentStatus.Completed, title: 'Завершено', id: 3 },
	//{ key: TreatmentStatus.NotRequired, title: 'Не требуется', id: 4 },
	{
		key: TreatmentStatus.DisposeRecommended,
		title: 'На выбытие',
		id: 5,
	},
]

export const inspectionStatuses: IInspection[] = [
	//{ key: InspectionStatus.Required, title: 'Требуется осмотр', id: 0 },
	{ key: InspectionStatus.Planned, title: 'Планируется', id: 1 },
	{ key: InspectionStatus.Expired, title: 'Просрочен', id: 2 },
	//{ key: InspectionStatus.Completed, title: 'Проведен', id: 3 },
	{ key: InspectionStatus.NotPlanned, title: 'Не планируется', id: 4 },
]

export const lactationStatuses: ILactation[] = [
	{ key: LactationStatus.Lactating, title: 'Дойная', id: 0 },
	{ key: LactationStatus.NonLactating, title: 'Сухостойная', id: 1 },
	{ key: LactationStatus.DefectiveMilk, title: 'Бракованное', id: 2 },
	{ key: LactationStatus.CommercialMilk, title: 'Товарное', id: 3 },
]

const treatmentStatusTranslations: { [key in TreatmentStatus]: string } = {
	[TreatmentStatus.NotPrescribed]: 'Не назначено',
	[TreatmentStatus.Suspended]: 'Приостановлено',
	[TreatmentStatus.Treated]: 'Лечится',
	[TreatmentStatus.Completed]: 'Завершено',
	[TreatmentStatus.NotRequired]: 'Не требуется',
	[TreatmentStatus.DisposeRecommended]: 'Рекомендована на выбытие',
}

const inspectionStatusTranslations: { [key in InspectionStatus]: string } = {
	[InspectionStatus.Required]: 'Требуется осмотр',
	[InspectionStatus.Planned]: 'Планируется',
	[InspectionStatus.Expired]: 'Просрочен',
	[InspectionStatus.Completed]: 'Проведён',
	[InspectionStatus.NotPlanned]: 'Не планируется',
}

const positionHoofTranslations: { [key in PositionHoof]: string } = {
	[PositionHoof.Front_Left]: 'Переднее левое',
	[PositionHoof.Front_Right]: 'Переднее правое',
	[PositionHoof.Rear_Left]: 'Заднее левое',
	[PositionHoof.Rear_Right]: 'Заднее правое',
	[PositionHoof.All]: 'Все',
}
export const initialChartInfo = [
	{
		label: '1 балл',
		color: COLORS.main,
		score: 1,
		category: [],
		timestamp: [],
		segmentValue: 0,
	},
	{
		label: '2 балла',
		color: COLORS.icon,
		score: 2,
		category: [],
		timestamp: [],
		segmentValue: 0,
	},
	{
		label: '3 балла',
		color: COLORS.health,
		score: 3,
		category: [],
		timestamp: [],
		segmentValue: 0,
	},
	{
		label: '4 балла',
		color: COLORS.error30,
		score: 4,
		category: [],
		timestamp: [],
		segmentValue: 0,
	},
	{
		label: '5 баллов',
		color: COLORS.error,
		score: 5,
		category: [],
		timestamp: [],
		segmentValue: 0,
	},
]
export const getTranslationStatus = (
	enumValue: TreatmentStatus | InspectionStatus | PositionHoof,
): string => {
	if (treatmentStatusTranslations.hasOwnProperty(enumValue)) {
		return treatmentStatusTranslations[enumValue as TreatmentStatus]
	}
	if (inspectionStatusTranslations.hasOwnProperty(enumValue)) {
		return inspectionStatusTranslations[enumValue as InspectionStatus]
	}
	if (positionHoofTranslations.hasOwnProperty(enumValue)) {
		return positionHoofTranslations[enumValue as PositionHoof]
	}
	return 'Неизвестный статус'
}

export const getSeriesData = (dotsInfo, visibleSeries, selectTypeOfChart) => {
	const noDataColor = COLORS.inputBorder

	if (selectTypeOfChart === LamenessTypeChart.PointType) {
		const series = []
		dotsInfo.forEach((el, index) => {
			if (el.score === 1 || !visibleSeries[index]) return
			series.push({
				name: `Нет данных ${el.label}`,
				data: buildInterpolatedSeries(el.category),
				color: noDataColor,
			})
			series.push({
				name: el.label,
				data: el.category,
				color: el.color,
			})
		})
		return series
	}

	const totalDays = dotsInfo[0]?.category.length ?? 0
	const lameDots = dotsInfo.filter(el => el.score !== 1)
	const summedData = Array.from({ length: totalDays }, (_, index) => {
		if (dotsInfo.every(el => el.category[index] == null)) return null
		return lameDots.reduce((sum, el) => sum + (el.category[index] ?? 0), 0)
	})

	return [
		{
			name: 'Нет данных',
			data: buildInterpolatedSeries(summedData),
			color: noDataColor,
		},
		{
			name: 'Общее количество голов',
			data: summedData,
			color: COLORS.black,
		},
	]
}

export const updateSeriesVisibilityBySelector = visibleSeries => {
	document.querySelectorAll('.apexcharts-line-series').forEach(el => {
		Array.from(el.children).forEach((child, childIndex) => {
			const childElement = child as HTMLElement
			childElement.style.display = visibleSeries[childIndex + 1]
				? 'block'
				: 'none'
		})
	})
}

export const useVisibleSeries = dotsInfo => {
	const [visibleSeries, setVisibleSeries] = useState(
		dotsInfo.map(dots => dots.score !== 1),
	)

	const handleCheckboxChange = index => {
		setVisibleSeries(prevVisibleSeries =>
			prevVisibleSeries.map((visible, i) => (i === index ? !visible : visible)),
		)
	}

	return [visibleSeries, handleCheckboxChange]
}

export const getColorByScoreForCrytical = (score: number, percent: number) => {
	switch (score) {
		case 1:
			return percent < 75 ? COLORS.error : COLORS.black
		case 2:
			return percent > 15 ? COLORS.error : COLORS.black
		case 3:
			return percent > 9 ? COLORS.error : COLORS.black
		case 4:
		case 5:
			return percent > 0.5 ? COLORS.error : COLORS.black
		default:
			return COLORS.black
	}
}

export const getColorByScore = score => {
	switch (score) {
		case 1:
			return COLORS.main
		case 2:
			return COLORS.icon
		case 3:
			return COLORS.health
		case 4:
			return COLORS.error30
		case 5:
			return COLORS.error
		default:
			return COLORS.secondary
	}
}
